import { render, staticRenderFns } from "./Inswper.vue?vue&type=template&id=18aa92f2&scoped=true"
import script from "./Inswper.vue?vue&type=script&lang=js"
export * from "./Inswper.vue?vue&type=script&lang=js"
import style0 from "./Inswper.vue?vue&type=style&index=0&id=18aa92f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa92f2",
  null
  
)

export default component.exports